import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface DeletePreRegistrationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  establishmentName: string;
  currentObservations: string | null;
  isPending: boolean;
  // The reason replaces the row's observations
  onConfirm: (reason: string) => void;
}

export const DeletePreRegistrationDialog: React.FC<DeletePreRegistrationDialogProps> = ({
  open,
  onOpenChange,
  establishmentName,
  currentObservations,
  isPending,
  onConfirm,
}) => {
  const [reason, setReason] = useState('');

  // Start from the current observations so they are not lost unintentionally
  useEffect(() => {
    if (open) setReason(currentObservations ?? '');
  }, [open, currentObservations]);

  const trimmed = reason.trim();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Eliminar alojamiento preinscripto</AlertDialogTitle>
          <AlertDialogDescription>
            "{establishmentName}" pasará a estado Eliminado. Se puede restaurar más adelante.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="space-y-2">
          <Label htmlFor="delete-reason">
            Motivo <span className="text-red-500">*</span>
          </Label>
          <Textarea
            id="delete-reason"
            value={reason}
            onChange={(event) => setReason(event.target.value)}
            placeholder="Por ejemplo: duplicado del listado de Tilcara"
            rows={3}
          />
          <p className="text-xs text-gray-500">El motivo queda guardado en las observaciones.</p>
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isPending}>Cancelar</AlertDialogCancel>
          <Button
            variant="destructive"
            disabled={trimmed === '' || isPending}
            onClick={() => onConfirm(trimmed)}
          >
            {isPending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Eliminar
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
